import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import Entypo from '@expo/vector-icons/Entypo';

import Colors from '../../../constants/Colors';

const styles = StyleSheet.create({
  view: {
    width: 120,
    height: 40,
    borderWidth: 1,
    borderRadius: 4,
    borderColor: Colors.inputGrayBorder,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  button: {
    width: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export type PlusMinus2Props = {
  onChange: (value: number) => void;
  value: number;
  min: number;
  max: number;
  testID: string;
};

/**
 * A component for inputting a single number by incrementing with +1/-1 buttons.
 * This is a 'controlled' component - it does not maintain state internally,
 * but renders based on the provided `value` prop and calls the `onChange` when the
 * value is changed
 */
function PlusMinus2(props: PlusMinus2Props) {
  const { onChange, min, max, testID, value } = props;

  const minusOne = (): void => {
    onChange(value - 1);
  };

  const plusOne = (): void => {
    onChange(value + 1);
  };
  const atMaxValue = value === max;
  const atMinValue = value === min;

  const plusColor = atMaxValue ? Colors.lightGray : Colors.black;
  const minusColor = atMinValue ? Colors.lightGray : Colors.black;

  return (
    <View style={styles.view} testID={testID}>
      <TouchableOpacity
        style={styles.button}
        onPress={minusOne}
        testID={`${testID}-minus`}
        disabled={atMinValue}
      >
        <Entypo name="minus" size={24} color={minusColor} />
      </TouchableOpacity>
      <Text testID={`${testID}-value`}>{value}</Text>
      <TouchableOpacity
        style={styles.button}
        onPress={plusOne}
        testID={`${testID}-plus`}
        disabled={atMaxValue}
      >
        <Entypo name="plus" size={24} color={plusColor} />
      </TouchableOpacity>
    </View>
  );
}

export default PlusMinus2;
